import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

import { Integrante, IntegranteFormInput } from '../integrante.model';
import { DocumentoPersonaFormComponent } from '../../../persona/documentos-persona/documento-persona-form/documento-persona-form.component';
import {
  ActividadCheckElement,
  ActividadConNombre
} from '../../entity-roles/roles.model';
import {
  DocumentoPersona,
  DocumentoPersonaFormInput,
  createEmptyDocumentoPersonaFormInput
} from '../../../persona/documentos-persona/documentos-persona.model';
import { FormActionType } from '@rpe/registro-personas-empresas-lib';

@Component({
  selector: 'rpe-integrante-form',
  templateUrl: './integrante-form.component.html',
  styleUrls: ['./integrante-form.component.css']
})
export class IntegranteFormComponent implements OnInit {
  @Input()
  set formInput(integranteFormInput: IntegranteFormInput) {
    if (integranteFormInput != null) {
      this._formInput = integranteFormInput;
    }
    this.actualizarActividadesConNom(integranteFormInput.actividadesConNombre);
  }

  get formInput(): IntegranteFormInput {
    return this._formInput;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<Integrante>();
  @ViewChild(DocumentoPersonaFormComponent, { static: true })
  documentoPersonaForm: DocumentoPersonaFormComponent;

  actividadesCheck: ActividadCheckElement[] = [];
  checkedList: boolean[] = [];
  actividadSinCheck: boolean = false;
  sinActividades: boolean = false;
  tituloIntegrante: string;

  _formInput: IntegranteFormInput = null;
  documentoPersonaFormInput: DocumentoPersonaFormInput =
    createEmptyDocumentoPersonaFormInput();
  integranteFormGroup: FormGroup;

  private ocultoAcreditacion = true;
  private ocultoCV = true;
  private ocultoActividades = true;

  //valida que se elija al menos un elemento
  minLengthArray = (min: number) => {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value.length >= min) return null;
      return { MinLengthArray: true };
    };
  };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.integranteFormGroup = this.fb.group({
      nombre_completo: [null, [Validators.required]],
      rol: this.fb.group({
        id: [null, []],
        persona_id: [null, []], //TODO ver esto
        entidad_productiva_id: [this.formInput.entidad_productiva_id, []],
        acreditacion_representacion: [null, []], //va a tener required cuando sea visible
        es_creador: [true, []],
        fecha_alta: [new Date().toISOString().split('T')[0], []],
        fecha_baja: [null, []],
        vinculo_aprobado_rol: [false, []],
        vinculo_aprobado_entidad_productiva: [true, []],
        eliminado: [false, []],
        tipo_rol_id: [null, [Validators.required]]
      }),
      documento_persona: this.fb.array([
        this.fb.group([this.documentoPersonaForm.createGroup()])
      ]),
      cv: [null, []], //va a tener required cuando sea visible
      actividades_id: this.fb.array([], [this.minLengthArray(1)])
    });

    // const selectedActividades = (this.integranteFormGroup.controls.actividades as FormArray);
    // (this.formInput.integrante?.actividades)?.forEach(a => {
    //   selectedActividades.push(new FormControl(a));
    //   document.querySelector(`#actCheck_${a}`)?.setAttribute("checked", 'true');
    //   console.log("#actCheck_${a}", document.querySelector(`#actCheck_${a}`))
    // });

    switch (this.formInput.action) {
      case FormActionType.View:
        this.tituloIntegrante = 'Ver Integrante';
        this.documentoPersonaFormInput.action = FormActionType.View;
        this.documentoPersonaForm.setSoloLectura(true);
        this.integranteFormGroup.disable();
        this.integranteFormGroup.get('actividades_id').disable();
        this.cargarIntegrante();
        break;
      case FormActionType.Update:
        this.tituloIntegrante = 'Editar integrante';
        this.documentoPersonaFormInput.action = FormActionType.View;
        this.integranteFormGroup.controls.nombre_completo.disable();
        //this.integranteFormGroup.get('documento_persona').disable();
        this.documentoPersonaForm.setSoloLectura(true);
        //this.integranteFormGroup.get('actividades_id').disable();
        this.integranteFormGroup.get('actividades_id').clearValidators;
        this.integranteFormGroup.get('actividades_id').updateValueAndValidity();
        this.cargarIntegrante();
        break;
      case FormActionType.Add:
        this.tituloIntegrante = 'Vincular integrante';
        this.documentoPersonaFormInput.action = FormActionType.Add;
        this.documentoPersonaForm.setSoloLectura(false);
        break;
      default:
        this.tituloIntegrante = 'Integrante';
        this.documentoPersonaFormInput.action = FormActionType.View;
    }

    // this.integranteFormGroup
    //   .get('rol')
    //   .get('acreditacion_representacion')
    //   .disable();
    // this.integranteFormGroup.get('cv').disable();

    // // emit events
    this.integranteFormGroup.valueChanges.subscribe((_) => {
      let auxDocumentos: any =
        this.integranteFormGroup.get('documento_persona').value;
      let documento: DocumentoPersona = null;
      if (auxDocumentos) {
        documento = auxDocumentos[0][0];
      }

      this.formValueChanges.emit({
        ...this.integranteFormGroup.getRawValue(), //obtiene los campos disabled
        documento_persona: documento
      });
    });

    this.integranteFormGroup.statusChanges.subscribe((f) => {
      this.formStatusChanges.emit(f);
    });
  }

  disabledCheckBox() {
    return this.formInput.action === FormActionType.View;
  }

  cargarIntegrante() {
    this.integranteFormGroup
      .get('nombre_completo')
      .setValue(this.formInput.integrante.nombre_completo);
    this.documentoPersonaFormInput = {
      ...this.documentoPersonaFormInput,
      documento_persona: this.formInput.integrante.documento_persona
    };
    /*this.documentoPersonaForm.setValorDocumento(
      this.formInput.integrante.documento_persona
    );*/
    this.integranteFormGroup.get('rol').setValue(this.formInput.integrante.rol);
    // this.integranteFormGroup
    //   .get('actividades_id')
    //   .setValue(this.formInput.integrante.actividades);

    const selectedActividades = this.integranteFormGroup.controls
      .actividades_id as FormArray;

    if (this.formInput.integrante.actividades_id) {
      this.formInput.integrante.actividades_id?.forEach((a) => {
        selectedActividades.push(new FormControl(a));
      });
      // this.ocultoActividades = false;
    }
  }

  ocultarActividad() {
    return this.ocultoActividades;
  }

  setOcultarAcreditacion(idTipoRol: number) {
    if (idTipoRol == 3 || idTipoRol == 11) {
      this.integranteFormGroup
        .get('rol')
        .get('acreditacion_representacion')
        .setValidators([Validators.required]);
      this.integranteFormGroup
        .get('rol')
        .get('acreditacion_representacion')
        .updateValueAndValidity();
      this.ocultoAcreditacion = false;
    } else {
      this.integranteFormGroup
        .get('rol')
        .get('acreditacion_representacion')
        .clearValidators();
      this.integranteFormGroup
        .get('rol')
        .get('acreditacion_representacion')
        .updateValueAndValidity();
      this.ocultoAcreditacion = true;
    }
  }

  ocultarAcreditacion() {
    return this.ocultoAcreditacion;
  }

  setOcultarCV(idTipoRol: number) {
    //solo se muestra cuando es del tipo 8
    if (idTipoRol == 8) {
      this.integranteFormGroup.get('cv').setValidators([Validators.required]);
      this.integranteFormGroup.get('cv').updateValueAndValidity();
      this.ocultoCV = false;
    } else {
      this.integranteFormGroup.get('cv').clearValidators();
      this.integranteFormGroup.get('cv').updateValueAndValidity();
      this.ocultoCV = true;
    }
  }

  ocultarCV() {
    return this.ocultoCV;
  }

  onCheckboxChange(event: any) {
    const selectedActividades = this.integranteFormGroup.controls
      .actividades_id as FormArray;
    let idCheck = Number(event.target.value);
    if (event.target.checked) {
      selectedActividades.push(new FormControl(idCheck));
    } else {
      const index = selectedActividades.controls.findIndex(
        (x) => x.value === idCheck
      );
      selectedActividades.removeAt(index);
    }
  }

  //devuelve si esta seleccionado a partir de los controls
  estaSeleccionado(id: number) {
    const selectedActividades = this.integranteFormGroup.controls
      .actividades_id as FormArray;
    const index = selectedActividades.controls.find((x) => x.value === id);
    return index != null;
  }

  onRolSelect(event: MatSelectChange): void {
    let idTipoRol = event.value;
    this.setOcultarAcreditacion(idTipoRol);
    this.setOcultarCV(idTipoRol);
    //vacia la lista de seleccionados
    const selectedActividades = this.integranteFormGroup.controls
      .actividades_id as FormArray;
    selectedActividades.clear();
    this.actividadesCheck = [];
  }

  // actualiza los valores venidos desde el input y setea las validaciones
  actualizarActividadesConNom(actividadesConNombre: ActividadConNombre[]) {
    actividadesConNombre?.forEach((aCN) => {
      this.actividadesCheck.push({
        value: true,
        actividadConNombre: aCN
      });
      this.checkedList.push(true);
    });

    if (this.integranteFormGroup == undefined) {
      if (this.formInput.actividadesConNombre.length > 0) {
        this.ocultoActividades = false;
      } else {
        this.ocultoActividades = true;
      }
      return;
    }

    if (this.formInput.actividadesConNombre.length > 0) {
      this.integranteFormGroup
        .get('actividades_id')
        .setValidators([this.minLengthArray(1)]);
      this.integranteFormGroup.get('actividades_id').updateValueAndValidity();
      this.ocultoActividades = false;
    } else {
      this.integranteFormGroup.get('actividades_id').clearValidators();
      this.integranteFormGroup.get('actividades_id').updateValueAndValidity();
      this.ocultoActividades = true;
    }
  }

  onFileChange(file: string) {}

  reset(): void {}

  onShowErrors(): void {
    this.integranteFormGroup.markAllAsTouched();
  }
}
